<template>
  <div class="">
    <label class="block">
      <span
        v-if="label"
        class="block uppercase font-bold text-gray-600 tracking-wider text-sm"
      >
        {{ label }}
      </span>
      <!-- eslint-disable max-len -->
      <select
        v-bind="$attrs"
        class="form-select block w-full"
        :class="[
          { 'text-gray-500': value === '' },
          { 'border border-red-500 bg-red-200 text-red-700 placeholder-red-500': localState === 'error' ? true : false},
          { 'border border-green-500 bg-green-200 text-green-700 placeholder-green-500': localState === 'success' ? true : false }
        ]"
        :value="value"
        @change="$emit('input', $event.target.value)"
      >
      <!-- eslint-enable max-len -->
        <option disabled value="">{{ defaultSelect }}</option>
        <option v-for="option in options" :key="option" :value="option">{{ option }}</option>
      </select>
    </label>
  </div>
</template>

<script>
// valid support states
const STATES = [
  '',
  'error',
  'success',
];

const arrayIncludes = (array, value) => array.indexOf(value) !== -1;

export default {
  name: 'MSelect',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    state: {
      type: String,
      default: '',
      validator: state => arrayIncludes(STATES, state),
    },
    defaultSelect: {
      type: String,
      default: 'Select...',
    },
  },
  computed: {
    localState() {
      return arrayIncludes(STATES, this.state) ? this.state : '';
    },
  },
};
</script>

<style>

</style>
